const styles = theme => ({})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/Layouts/FullScreen/styles.js